exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.table-cell[data-v-7fb797e2]{display:table-cell;height:36px;border:1px solid #e5e5e5}\n", ""]);

// exports
